import { ShortCode } from '@highereducation/wordpress';
import { GridImage } from '@highereducation/hen-ui';

type GridImageShortcodeProps = {
  src?: string;
  alt?: string;
  width?: string;
  height?: string;
  padding?: 'none' | 'default';
};

/**
 * GridImageShortcode - Shortcode wrapper for GridImage composite component
 *
 * Handles prop conversion from WordPress shortcode attributes (strings) to
 * component props (typed values).
 *
 * GridImage is a composite component that applies the necessary className
 * ('object-contain max-w-full max-h-full') to ensure images display correctly
 * within ImageGrid's grid layout.
 *
 * Supported shortcode attributes:
 * - src: string (required) - Image source URL
 * - alt: string (optional) - Alt text for the image
 * - width: number (optional) - Image width
 * - height: number (optional) - Image height
 *
 * @example WordPress shortcode usage:
 * [hen-ui-grid-image src="/path/to/image.png" alt="Image description" /]
 *
 * @example Component usage:
 * <GridImage src="/path/to/image.png" alt="Image description" />
 */
export const GridImageShortcode: ShortCode<GridImageShortcodeProps> = {
  component: ({ src, alt, width, height, padding }) => {
    if (!src) {
      console.warn('GridImageShortcode: src is required');
      return null;
    }

    const parsedWidth = width ? parseInt(width, 10) : undefined;
    const parsedHeight = height ? parseInt(height, 10) : undefined;

    return (
      <GridImage
        src={src}
        alt={alt}
        width={parsedWidth}
        height={parsedHeight}
        padding={padding}
      />
    );
  },
};
